<template>
  <Popup v-model="message.show" :centered="true">
    <h2 class="pfpopup__title" v-html="message.title"></h2>
    <p class="pfpopup__text" v-if="message.text" v-html="message.text.trim()"></p>
    <Btn class="pfpopup__btn" v-if="message.btnText" @click.stop.prevent="$store.commit('hideMessage')">{{message.btnText}}</Btn>
  </Popup>
</template>

<script>
import { mapState } from 'vuex'
import Popup from './Popup.vue'
import Btn from './Btn.vue'

export default {
  components: { Popup, Btn },
  mounted(){
    console.log(this.message)
  },
  computed: {
    ...mapState({message: ({ popup: { message } }) => message})
  },
  watch: {
    'message.show': function(v, old) {
      if (this.message.redirect && !v && old) {
        window.location.assign(this.message.redirect)
      }
    }
  }
}
</script>

<style lang="sass">

</style>